import {keys, map} from 'lodash'
import {Tooltip} from 'react-tooltip'
import {browserStyles, browserToScreenRatio, getDefaultBrowserConfig} from '../constants'

export const BrowserOptions = props => {
  const {
    allowBrowser,
    browserOptions,
    onAllowBrowserChange = () => {},
    onOptionsChange = () => {},
    edit = false,
    disabled = false
  } = props

  const onAdd = () => {
    onOptionsChange([...browserOptions, getDefaultBrowserConfig()])
  }

  const onRemove = index => {
    if (index > 0) {
      const next = [...browserOptions]
      next.splice(index, 1)
      onOptionsChange(next)
    }
  }

  const onUpdate = (index, property, value) => {
    const updated = {...browserOptions[index]}
    updated[property] = value
    const next = [...browserOptions]
    next.splice(index, 1, updated)
    onOptionsChange(next)
  }

  return (
    <div className={disabled ? 'area-disabled' : ''}>
      <h4>Browser Options</h4>

      <div className="row mb-4">
        <div className="col-sm-5">Allow Web Browser</div>
        <div className="col-sm-7">
          <select
            className="form-control"
            value={allowBrowser ? '1' : '0'}
            onChange={e => onAllowBrowserChange(!!Number(e.target.value))}
            disabled={disabled}
          >
            <option value="1">Yes</option>
            <option value="0" selected>
              No
            </option>
          </select>
        </div>
      </div>

      {browserOptions.map((config, index) => (
        <div key={`browser-options-${index}`}>
          <div className="row mb-4">
            <div className="col-sm-5">Set Specific URL?</div>
            <div className="col-sm-7">
              <select
                className="form-control"
                value={config.specificUrl ? '1' : '0'}
                onChange={e => onUpdate(index, 'specificUrl', !!Number(e.target.value))}
              >
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>
          </div>

          {config.specificUrl && (
            <div className="row mb-4">
              <div className="col-sm-5">URL for Browser</div>
              <div className="col-sm-7 d-flex justify-content-end">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter url for browser view"
                  value={config.url}
                  onChange={e => onUpdate(index, 'url', e.target.value)}
                />
              </div>
            </div>
          )}

          <div className="row mb-4">
            <div className="col-sm-5">Custom browser button name</div>
            <div className="col-sm-7 d-flex justify-content-end">
              <input
                type="text"
                className="form-control"
                placeholder="Enter Custom name"
                value={config.buttonName}
                onChange={e => onUpdate(index, 'buttonName', e.target.value)}
              />
            </div>
          </div>

          <div className="row mb-4">
            <div className="col-sm-5">Allow Search bar</div>
            <div className="col-sm-7">
              <select
                className="form-control"
                value={config.allowSearchBar ? '1' : '0'}
                onChange={e => onUpdate(index, 'allowSearchBar', !!Number(e.target.value))}
              >
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>
          </div>

          <div className="row mb-4">
            <div className="col-sm-5">Allow new tabs</div>
            <div className="col-sm-7">
              <select
                className="form-control"
                value={config.allowNewTabs ? '1' : '0'}
                onChange={e => onUpdate(index, 'allowNewTabs', !!Number(e.target.value))}
              >
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>
          </div>

          <div className="row mb-4">
            <div className="col-sm-5">Allow Keyboard</div>
            <div className="col-sm-7">
              <select
                className="form-control"
                value={config.allowKeyboard ? '1' : '0'}
                onChange={e => onUpdate(index, 'allowKeyboard', !!Number(e.target.value))}
              >
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>
          </div>

          <div className="row mb-4">
            <div className="col-sm-5">Set session expiration time?</div>
            <div className="col-sm-7">
              <select
                className="form-control"
                value={config.sessionExpiryLimit ? '1' : '0'}
                onChange={e => onUpdate(index, 'sessionExpiryLimit', !!Number(e.target.value))}
              >
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>
          </div>

          {config.sessionExpiryLimit && (
            <div className="row mb-4">
              <div className="col-sm-5">Timer</div>
              <div className="col-sm-7 d-flex justify-content-end">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter browser session limit in minutes"
                  value={config.sessionExpiryTime}
                  onChange={e => onUpdate(index, 'sessionExpiryTime', Number(e.target.value))}
                />
              </div>
            </div>
          )}

          <div className="row mb-4">
            <div className="col-sm-5">Browser style</div>
            <div className="col-sm-7">
              <select
                className="form-control"
                value={config.browserStyle}
                onChange={e => onUpdate(index, 'browserStyle', e.target.value)}
              >
                <option value={browserStyles.overlay}>Overlay</option>
                <option value={browserStyles.sideBySide}>Side-by-Side</option>
                <option value={browserStyles.replace}>Replace</option>
              </select>
            </div>
          </div>

          {config.browserStyle === browserStyles.sideBySide && (
            <div className="row mb-4">
              <div className="col-sm-5">
                Browser to screen ratio
                <i data-tooltip-id={`${index}-screen-ratio-info`} className="fa fa-info-circle ml-2"></i>
                <Tooltip
                  id={`${index}-screen-ratio-info`}
                  place="top"
                  content="Browser:Video Window view scale. i.e. 1:1 is equal to 50-50% for each."
                />
              </div>
              <div className="col-sm-7">
                <select
                  className="form-control"
                  value={config.browserToScreenRatio}
                  onChange={e => onUpdate(index, 'browserToScreenRatio', e.target.value)}
                >
                  {map(keys(browserToScreenRatio), (key, j) => (
                    <option key={`${index}-${j}-${key}`} value={key}>
                      {browserToScreenRatio[key]}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}

          <div className="row mb-4">
            <div className="col-sm-5">Enable Cache?</div>
            <div className="col-sm-7">
              <select
                className="form-control"
                value={config?.cache ? '1' : '0'}
                onChange={e => onUpdate(index, 'cache', !!Number(e.target.value))}
              >
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>
          </div>

          {
            edit && config?.cache ? <div className="row mb-4">
              <div className="offset-sm-5 col-sm-7">
                <button className="btn btn-primary btn-block">
                  <i className="fal fa-database"></i> &nbsp; Clear Cache Now
                </button>
              </div>
            </div> : null
          }

          <div className="row mb-4">
            <div className="col-sm-5">Continue where you left off?</div>
            <div className="col-sm-7">
              <select
                className="form-control"
                value={config?.continueLeftOff ? '1' : '0'}
                onChange={e => onUpdate(index, 'continueLeftOff', !!Number(e.target.value))}
              >
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>
          </div>

          <div className="row mb-4">
            <div className="col-sm-7 offset-sm-5">
              {index === 0 ? (
                <button className="btn btn-primary btn-block" onClick={onAdd}>
                  Add additional browser button
                </button>
              ) : (
                <button className="btn btn-danger btn-block" onClick={() => onRemove(index)}>
                  Remove additional button
                </button>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
